import { Dayjs } from 'dayjs';
import { mixed, object, number } from 'yup';

import { YUP_ERRORS_MESSAGES } from '@shared/constants';

export const exportWinStreaksFormValidationSchema = object().shape({
  startDate: mixed<Dayjs>().required(YUP_ERRORS_MESSAGES.REQUIRED),
  endDate: mixed<Dayjs>().required(YUP_ERRORS_MESSAGES.REQUIRED),
  limit: number().required(YUP_ERRORS_MESSAGES.REQUIRED),
});
